import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import YoutubePlay from '@elem/SVGIcon/OutdoorRecreation/YoutubePlay';
import css from './index.module.scss';
import GuideLink from './components/GuideLink';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function M() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const [source, setSource] = useState('');
    const [gap, setGap] = useState(24);
    // 本地化youtube视频
    const video4_poster: any = {
        us: 'https://websiteoss.ecoflow.com/upload/image/1748227417565/12_4',
        ca: 'https://websiteoss.ecoflow.com/upload/image/1748227417565/12_4',
        uk: '/responsive/picture/outdoor-recreation/12_5',
        eu: '/responsive/picture/outdoor-recreation/12_5',
        de: '/responsive/picture/outdoor-recreation/12_4',
        fr: '/responsive/picture/outdoor-recreation/12_4',
        it: '/responsive/picture/outdoor-recreation/12_4',
        es: '/responsive/picture/outdoor-recreation/12_4',
        za: '/responsive/picture/outdoor-recreation/12_4',
        au: '/responsive/picture/outdoor-recreation/12_4',
    };
    const cards: any = [
        {
            img: '/responsive/picture/outdoor-recreation/12_1',
            text: t('secM_list1'),
            video: (() => {
                const map: any = {
                    us: 'https://www.youtube.com/embed/Au6hRX3eiik?si=5PiXZv2sRqUNb0sV',
                    de: 'https://www.youtube.com/embed/BljtM9_XTs4?si=zQgK82U2JjW5sism',
                    za: 'https://www.youtube.com/embed/xLcCU29riWE?si=za-NI7Ghpi12c87Z',
                    fr: 'https://www.youtube.com/embed/PzczrIeflPs?si=If5OF6H-98cKHH9_',
                    uk: 'https://www.youtube.com/embed/Au6hRX3eiik?si=JbrCGy5ED1YM3icZ',
                    eu: 'https://www.youtube.com/embed/Au6hRX3eiik?si=JbrCGy5ED1YM3icZ',
                    it: 'https://www.youtube.com/embed/R_dvRU7S-9g?si=j_X-wggzYCy7HrEj',
                    es: 'https://www.youtube.com/embed/JKo_Gqg-PPA?si=aZaGD9JaAFql5lEX',
                    au: 'https://www.youtube.com/embed/EYAPKD1_ye0?si=my7PsZUSlznKFDV1',
                    kr: 'https://www.youtube.com/embed/Au6hRX3eiik?si=cy-nfpx9FXKL4rUH',
                };
                return map[locale] || map.us;
            })(),
        },
        {
            img: '/responsive/picture/outdoor-recreation/12_2',
            text: t('secM_list2'),
            video: (() => {
                const map: any = {
                    us: 'https://www.youtube.com/embed/wuVrQqlyqMQ?si=Huc2e-aV_p1wJhJk',
                    de: 'https://www.youtube.com/embed/dRhR4K6ysA0?si=9OkxtDoRIqFwMlo5',
                    za: 'https://www.youtube.com/embed/cLUIyKrd9ts?si=C8VPQT-30jqwfYZk',
                    fr: 'https://www.youtube.com/embed/NwA31h4QAvM?si=1PG9PxOnfTrlib-T',
                    uk: 'https://www.youtube.com/embed/Zlaw1AwPGIo?si=CZfiKkUZ3gYZxrph',
                    eu: 'https://www.youtube.com/embed/Zlaw1AwPGIo?si=CZfiKkUZ3gYZxrph',
                    it: 'https://www.youtube.com/embed/AYCXJWGLx4k?si=t74ek3eb0MprLWue',
                    es: 'https://www.youtube.com/embed/EtX5nt4vMMI?si=IIgN9SsN-xEUsNcY',
                    au: 'https://www.youtube.com/embed/3uO9fLnurB8?si=MVL02w4gWJQ4KD2c',
                    kr: 'https://www.youtube.com/embed/wuVrQqlyqMQ?si=M5vAa_N_4bm-G77N',
                };
                return map[locale] || map.us;
            })(),
        },
        {
            img: '/responsive/picture/outdoor-recreation/12_3',
            text: t('secM_list3'),
            video: (() => {
                const map: any = {
                    us: 'https://www.youtube.com/embed/a2npZ_toi7U?si=YyGUe8bUfiKIv1NH',
                    de: 'https://www.youtube.com/embed/XtN6-CLbzt8?si=xOaEKuHeHKMB-X7g',
                    za: 'https://www.youtube.com/embed/ULol9L_07_E?si=qi0WrQYGkVytYIKX',
                    fr: 'https://www.youtube.com/embed/jvtgKyf0peY?si=uc-DBTE3rq0GUuu3',
                    uk: 'https://www.youtube.com/embed/a2npZ_toi7U?si=Ulc5N7G76VIYBP6J',
                    eu: 'https://www.youtube.com/embed/a2npZ_toi7U?si=Ulc5N7G76VIYBP6J',
                    it: 'https://www.youtube.com/embed/Qf1quY7g06I?si=cFWb_QCL2fgDSRH2',
                    es: 'https://www.youtube.com/embed/D1MzXWG0wDM?si=cRzkVMAmX4saZ1if',
                    au: 'https://www.youtube.com/embed/9AFTKYwuFLk?si=z1hNqbjtc5eX0ePQ',
                    kr: 'https://www.youtube.com/embed/a2npZ_toi7U?si=L3944NXdFYuMkIbl',
                };
                return map[locale] || map.us;
            })(),
        },
        {
            img: video4_poster[locale] || video4_poster.us,
            text: t('secM_list4'),
            video: (() => {
                const map: any = {
                    us: 'https://m.youtube.com/watch?v=JmjZ5uNBagE',
                    ca: 'https://m.youtube.com/watch?v=JmjZ5uNBagE',
                    de: 'https://www.youtube.com/embed/1SpIn7D11nI?si=CcGQnTZ7amVXiM12',
                    za: 'https://www.youtube.com/embed/a2npZ_toi7U?si=ox5od9JlDnPJwiaK',
                    fr: 'https://www.youtube.com/embed/f-OCUmzlJ2M?si=FXggDmIJ2DQvevVA',
                    uk: 'https://www.youtube.com/embed/cLUIyKrd9ts?si=X0P_LbZ32qIy7sUY',
                    eu: 'https://www.youtube.com/embed/cLUIyKrd9ts?si=X0P_LbZ32qIy7sUY',
                    it: 'https://www.youtube.com/embed/oZ9uDVLasZ0?si=BM-4B2Q39xelOXjG',
                    es: 'https://www.youtube.com/embed/4SHLQQ3ukUs?si=aqIFo7hsK3xnzk6G',
                    au: 'https://www.youtube.com/embed/iDJsRGC-qvg?si=5W4eDl-DUV1TEeEd',
                    kr: '',
                };
                return map[locale] || map.us;
            })(),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    return (
        <div id="outdoor-recreation-M" className={`outdoor-recreation-M ${css['outdoor-recreation-M']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secM_title')}</p>
                </div>
                {['us', 'ca'].includes(locale) ? <GuideLink /> : null}
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar]}
                    spaceBetween={gap}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {(['kr'].includes(locale) ? [cards[0], cards[1], cards[2]] : cards)?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k} onClick={() => setSource(card?.video)}>
                            <EFPicture src={`${card?.img}.jpg`} alt={card?.text} />
                            <YoutubePlay className="youtube-icon" />
                            <p className="card-text">{card?.text}</p>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {Object.keys(source)?.length > 0 && (
                <EFVideoModal visible={Boolean(source)} source={source} onClose={() => setSource('')} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
            )}
        </div>
    );
}
